import { Traitement } from "@jack-sparrow-libraries/emotion-models";
import { TraitementAction, TraitementActionTypes } from "./traitement.action";
import { SeanceDTOV1 } from "@featuresAY/ordonnances/detail/traitements/seances/shared/V1/seance.dto.model";

export interface TraitementState {
	traitement: Traitement;
	loaded: boolean;
	loading: boolean;
	error: any;
	seances: SeanceDTOV1[];
}

export const traitementInitialState: TraitementState = {
	traitement: null,
	loaded: true,
	loading: false,
	error: null,
	seances: [],
};

export function traitementReducer(state: TraitementState = traitementInitialState, action: TraitementAction) {
	switch (action.type) {
		case TraitementActionTypes.ClotureTraitementWithDate:
		case TraitementActionTypes.SuspendreListTraitementBetweenDates:
		case TraitementActionTypes.ReprendreListTraitementBetweenDates:
		case TraitementActionTypes.DeleteTraitement: {
			return {
				...state,
				loading: true,
				loaded: false,
			};
		}
		case TraitementActionTypes.ClotureTraitementWithDateSuccess: {
			return {
				...state,
				loading: false,
				loaded: true,
				traitement: action.payload,
			};
		}
		case TraitementActionTypes.SuspendreListTraitementBetweenDatesSuccess:
		case TraitementActionTypes.ReprendreListTraitementBetweenDatesSuccess:
		case TraitementActionTypes.DeleteTraitementSuccess: {
			return {
				...state,
				loading: false,
				loaded: true,
			};
		}
		case TraitementActionTypes.DeleteTraitementError: {
			// Échec du DELETE : on remet le state cohérent (pas de loading figé après l'erreur).
			return {
				...state,
				loading: false,
				loaded: true,
			};
		}
		case TraitementActionTypes.ClotureTraitementWithDateError:
		case TraitementActionTypes.SuspendreListTraitementBetweenDatesError:
		case TraitementActionTypes.ReprendreListTraitementBetweenDatesError:

		default:
			return state;
	}
}
